import React from 'react';
import { useTranslation } from 'react-i18next';
import { Users } from 'lucide-react';

import { Card, CardContent } from '@/components/ui/card';

interface OnlineVisitorsCardProps {
  visitors: number;
  semanticColors?: unknown;
}

/**
 * Who is on the visualizer right now.
 *
 * The one live number on the page, so it keeps its pulsing dot — the only
 * moving thing here, which is what makes it read as live rather than as
 * another statistic.
 */
export const OnlineVisitorsCard = ({ visitors }: OnlineVisitorsCardProps) => {
  const { t } = useTranslation();

  return (
    <Card className="relative justify-between gap-0 py-4">
      <CardContent className="px-4">
        <Users className="absolute end-4 top-4 size-4 text-muted-foreground" />

        <div className="mb-2 flex items-center gap-2">
          <span className="relative flex size-2">
            <span className="absolute inline-flex size-full animate-ping rounded-full bg-success opacity-75" />
            <span className="relative inline-flex size-2 rounded-full bg-success" />
          </span>
          <p className="text-sm text-muted-foreground">{t('PAGES.DASHBOARD.ONLINE_NOW')}</p>
        </div>

        <span className="font-heading text-3xl leading-none font-medium tracking-tight">{visitors}</span>
      </CardContent>
    </Card>
  );
};
